export const nzCorporate = {
  name: 'NZFSG Adviser Services',
  email: 'adviserservices@nzfsg.co.nz',
};
